import { STAT_GROUPS } from "../consts";
import Stat from "../models/Stat";

export function getStatGroup(stat: Stat, group: STAT_GROUPS): number {
  return stat.get(group);
}
